export enum UserRoleName {
  SysAdmin = 'System Admin',
  PartnerAdmin = 'Partner Admin',
  PartnerTechnician = 'Partner Technician',
  OrganisationAdmin = 'Organisation Admin',
  OrganisationUser = 'Organisation User',
  SiteFuelDataContributor = 'Site Fuel Data Contributor',
  SiteUser = 'Site User',
  FuelDataContributor = 'Fuel Data Contributor',
}
